// src/components/Home.js

import React, { useState, useEffect, useRef } from "react";
import "./Chat.component.css";
// import image from "../../image.png";
// import playicon from "../../play_icon.svg";
import close from "../../images/close_icon.svg";
import arrow from "../../images/arrow.svg";
import disbleArrow from "../../images/disable_arrow.png";
import micicon from "../../images/mic-icon.png";
// import {
//     MainContainer,
//     ChatContainer,
//     MessageList,
//     Message,
//     MessageInput,
//     TypingIndicator,
// } from "@chatscope/chat-ui-kit-react";
import { useNavigate } from "react-router-dom";
const Chat = () => {
  const API_KEY =
    "sk-lXVRfUxv8OJgqCBIvPpjh2lcLiIDVycTB3t5uVnJjTT3BlbkFJnyNU-GJctSgzh4jUtzOAqVPzs1uNEZvQiFqlQK4ccA";

  const [isChat, setIsChat] = useState();
  const [typing, setTyping] = useState(false);
  const [msg, setMsg] = useState("");
  const chatContainerRef = useRef(null);
  const [conversation, setConversation] = useState([]);

  const handleOnChange = (e) => {
    setMsg(e.target.value);
  };
  const handleSend = () => {
    console.log(msg);

    if (msg) {
      const newMessage = {
        message: msg,
        sender: "user",
        direction: "outgoing",
      };
      setConversation((prevConversation) => [...prevConversation, newMessage]);
      setTyping(true);
      setMsg("");

      setTimeout(() => {
        processMessageToChatGPT(msg);
      }, 2000);
    }
  };
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, ["messages"]);
  useEffect(() => {
    chatContainerRef.current?.lastElementChild?.scrollIntoView();
  }, [conversation]);

  const processMessageToChatGPT = async (messageHistory) => {
    setMsg("");
    const key =
      "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";
    const response = await fetch(
      "https://api.openai.com/v1/images/generations",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prompt: messageHistory,
          model: "dall-e-3",
          n: 1,
          size: "1024x1024",
          quality: "hd",
          style: "natural",
        }),
      }
    );
    const data = await response.json();
    console.log(data);

    const imageUrl = data.data[0].url;
    // const data = await response.json();
    if (imageUrl) {
      const assistantMessage = {
        message: imageUrl,
        sender: "Penny",
        direction: "incoming",
      };
      setTyping(false);
      setConversation((prevConversation) => [
        ...prevConversation,
        assistantMessage,
      ]);
    }
  };
  const navigate = useNavigate();

  return (
    <>
      <div className="home-container">
        <div className="container">
          <div className="chat-container">
            {
              <div
                className="messages"
                ref={chatContainerRef}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                onKeyUp={(e) => e.key === "Enter" && handleSend()}
                tabIndex="0"
                style={{
                  overflowY: "auto",
                }}
              >
                {conversation.map((msg, index) =>
                  msg.direction == "incoming" ? (
                    <div
                      key={index}
                      className={`message ${
                        msg.direction === "outgoing" ? "outgoing" : "incoming"
                      }`}
                    >
                      <div className="message-content">
                        <img
                          src={msg.message}
                          alt="AI"
                          style={{ width: 512, height: 512 }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      key={index}
                      className={`message ${
                        msg.direction === "outgoing" ? "outgoing" : "incoming"
                      }`}
                    >
                      <div className="message-content">
                        <p>{msg.message}</p>
                      </div>
                    </div>
                  )
                )}
              </div>
            }
          </div>
        </div>

        {typing && (
          <div className="typing">
            <div class="ball"></div>
            <div class="ball"></div>
            <div class="ball"></div>
          </div>
        )}
        <div className="message-input">
          <input
            type="text"
            placeholder="Message"
            value={msg}
            onFocus={() => {
              setIsChat(true);
            }}
            onChange={handleOnChange}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button
            disabled={msg == "" ? true : false}
            className={`${msg == "" ? "disabled" : "send-button"}`}
            onClick={() => handleSend()}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          >
            <img src={arrow} alt="" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Chat;
